import MuiBox from "@mui/material/Box";
import MuiTypography from "@mui/material/Typography";
import React from "react";
import { COLORS } from "../../../styles/constants.style";
import { MultiOptionsDataType } from "../MuiMultiSelect";

interface RenderValueProps {
  showDoubleLabel: boolean;
  options: MultiOptionsDataType[];
  selectedItem: string | number;
  selectPlaceHolder: string;
}

const RenderValue: React.FC<RenderValueProps> = ({
  showDoubleLabel,
  options,
  selectedItem,
  selectPlaceHolder,
}) => {
  if (showDoubleLabel) {
    const selectedItemObj = options.find(
      (option) => option.value === selectedItem,
    );

    if (selectedItemObj) {
      return (
        <MuiBox className="selected-country-display">
          {selectedItemObj.iconUrl && (
            <img
              src={selectedItemObj.iconUrl}
              alt={selectedItemObj.label}
              className="country-icon"
            />
          )}
          <span className="label-name">{selectedItemObj.label}</span>
          {selectedItemObj.additionalInfo && (
            <span className="label-code">{selectedItemObj.additionalInfo}</span>
          )}
        </MuiBox>
      );
    }
    return (
      <MuiTypography variant="body3SemiBold" color={COLORS.cirrus_black5}>
        {selectPlaceHolder}
      </MuiTypography>
    );
  }

  return (
    <MuiTypography variant="body3SemiBold" color={COLORS.cirrus_black5}>
      {selectPlaceHolder}
    </MuiTypography>
  );
};

export default RenderValue;
